import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';

import BookingsFinance from './BookingsFinance';
import Header from './Header';
import OrganisationalBookings from './OrganisationalBookings';
import { useStyles } from './style';
import { Page } from '../../../../components';

interface BookingsProps {}

const Bookings = (props: BookingsProps) => {
	const location = useLocation();
	const { t } = useTranslation();

	const { date, title, id, name } = useParams();

	const classes = useStyles();
	return (
		<Page className={classes.root} title={t('ui.finance')}>
			<Header date={date} id={id} name={name} title={title} />
			<Box pt={3}>
				<BookingsFinance date={date} id={id} partnerId={location.state.organisationId} />
			</Box>
			<OrganisationalBookings
				date={date}
				id={id}
				name={name}
				partnerId={location.state.organisationId}
				title={title}
			/>
		</Page>
	);
};

export default Bookings;
